import { EventEmitter, Injectable } from '@angular/core';
import { ConfiguracionInicialService } from './configuracioninicial.service';
import { ComunicacionapiService } from './comunicacionapi.service';
import { Constantes } from '../models/modules/Constantes';
import { Observable } from 'rxjs/internal/Observable';
import { Menu } from '../models/generic/Menu';

@Injectable({
  providedIn: 'root'
})
export class MenuService {
  
  ListaMenu: Menu[] = [];
  ParametrosAdicionales: string = '';
  IconoAdicionarServicio: string = 'add';
  MostrarIconoServicio: boolean = false;
  CodigoComponenteActivo: string = '';
  public NotificarCambiarComponenteActivo: EventEmitter<string> = new EventEmitter<string>();
  public NotificarAccionBotonPrincipal: EventEmitter<string> = new EventEmitter<string>();
  public NotificarRecargarExpedientes: EventEmitter<string> = new EventEmitter<string>();

    
  constructor(private configInicial: ConfiguracionInicialService,
    private comunicacionapiService: ComunicacionapiService) {
      
  }

  EsPadre(menu: Menu): boolean {
    return menu.idMenuPadre === -1 ? true : false;
  }
  TieneHijos(menu: Menu): boolean {
    return this.ListaMenu.filter(x => x.idMenuPadre === menu.idMenu).length > 0 ? true : false;
  }
  HijosMenu(menu: Menu): Menu[] {
    return this.ListaMenu.filter(x => x.idMenuPadre === menu.idMenu);
  }
  MenusPadre(): Menu[] {
    return this.ListaMenu.filter(x => x.idMenuPadre === -1);
  }

  RegistrarSesionUsuario(): Observable<any> {
    let urlServicio: string = `${this.configInicial.ConfigLocal.UrlServicioAutorizacion}${Constantes.USUARIO_SESION()}`;
    return this.comunicacionapiService.PostAutorization(urlServicio);
  }

  ConsultarMenuSedeUsuario(): Observable<any> {
    let urlServicio: string = `${this.configInicial.ConfigLocal.UrlServicioAutorizacion}${Constantes.USUARIO_MENUSEDE()}`;
    return this.comunicacionapiService.PostAutorization(urlServicio);
  }

  CambiarComponenteActivo(codigoComponente: string, parametrosAdicionales: string = '') {
    // console.log('CambiarComponenteActivo', codigoComponente, parametrosAdicionales);
    this.CodigoComponenteActivo = codigoComponente;
    this.ParametrosAdicionales = parametrosAdicionales;
    this.NotificarCambiarComponenteActivo.emit(codigoComponente);
  }

  EjecutarNotificarAccionBotonPrincipal() {
    this.NotificarAccionBotonPrincipal.emit(this.IconoAdicionarServicio);
  }

  TienePermisoEscrituraEnMenu(nombreComponente: string): boolean {
    let tienePermisoEscritura: boolean = false;
    for (let index = 0; index < this.ListaMenu.length; index++) {
      if (this.ListaMenu[index].componente === nombreComponente) {
        tienePermisoEscritura = this.ListaMenu[index].escritura;
      }
    }
    return tienePermisoEscritura;
  }
  ObtenerTituloOpcionComponente(nombreComponente: string): string {
    let retornoTitulo: string = '';
    for (let index = 0; index < this.ListaMenu.length; index++) {
      if (this.ListaMenu[index].componente === nombreComponente) {
        retornoTitulo = this.ListaMenu[index].nombreMenu;
      }
    }
    return retornoTitulo;
  }
  TieneSeleccionadoComponente(codigoComponente: string): boolean {
    if (this.CodigoComponenteActivo === codigoComponente) {
      return true;
    }
    return false;
  }
}
